import Cookies from "js-cookie";
import {
  GET_MATERIAL_FOLDERS_INSTITUTION_URL,
  GET_MATERIALS_IN_INSTITUTION,
  CREATE_MATERIAL_FOLDER_INSTITUTION_URL,
  UPDATE_MATERIAL_FOLDER_INSTITUTION_URL,
  DELETE_MATERIAL_FOLDER_INSTITUTION_URL,
  CREATE_MATERIAL_IN_INSTITUTION,
  UPDATE_MATERIAL_IN_INSTITUTION,
  DELETE_MATERIAL_IN_INSTITUTION,
  GET_ADMIN_MATERIALS_FOLDER_IN_INSTITUTION,
  GET_ADMIN_MATERIALS_IN_INSTITUTION,
} from "../../apiurls/apiurls";

const getInstitutionToken = () => {
  return Cookies.get("institution_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getInstitutionToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getMaterialFoldersInstitution = async (title, key) => {
  const params = new URLSearchParams();
  if (title) params.append("title", title);
  if (key) params.append("key", key);

  const response = await fetch(
    `${GET_MATERIAL_FOLDERS_INSTITUTION_URL}?${params.toString()}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getAdminMaterialFolderInInstitution = async (title, key) => {
  const params = new URLSearchParams();
  if (title) params.append("title", title);
  if (key) params.append("key", key);

  const response = await fetch(
    `${GET_ADMIN_MATERIALS_FOLDER_IN_INSTITUTION}?${params.toString()}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const createMaterialFolderInstitution = async (payload) => {
  const response = await fetch(CREATE_MATERIAL_FOLDER_INSTITUTION_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const updateMaterialFolderInstitution = async (id, name) => {
  if (!id) throw new Error("Folder id is required for update");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(
    `${UPDATE_MATERIAL_FOLDER_INSTITUTION_URL}?${params.toString()}`,
    {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify({ name }),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const deleteMaterialFolderInstitution = async (id) => {
  if (!id) throw new Error("Folder id is required for delete");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(
    `${DELETE_MATERIAL_FOLDER_INSTITUTION_URL}?${params.toString()}`,
    {
      method: "DELETE",
      headers: getHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const getMaterialsInstitution = async (paramsObj = {}) => {
  const params = new URLSearchParams();
  Object.entries(paramsObj).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") {
      params.append(k, v);
    }
  });

  const response = await fetch(`${GET_MATERIALS_IN_INSTITUTION}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getAdminMaterialsInInstitution = async (paramsObj = {}) => {
  const params = new URLSearchParams();
  Object.entries(paramsObj).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") {
      params.append(k, v);
    }
  });

  const response = await fetch(`${GET_ADMIN_MATERIALS_IN_INSTITUTION}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const createMaterialInstitution = async (payload, file = null) => {
  if (file) {
    const formData = new FormData();
    
    Object.keys(payload).forEach(key => {
      if (key !== 'content') { 
        formData.append(key, payload[key]);
      }
    });
    
    formData.append('file', file);
    
    const response = await fetch(CREATE_MATERIAL_IN_INSTITUTION, {
      method: "POST",
      headers: {
        ...getHeadersWithoutContentType()
      },
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } else {
    const response = await fetch(CREATE_MATERIAL_IN_INSTITUTION, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
};

export const updateMaterialInstitution = async (id, payload, file = null) => {
  if (!id) throw new Error("Material id is required for update");
  
  const params = new URLSearchParams();
  params.append("id", id);
  
  if (file) {
    const formData = new FormData();
    
    Object.keys(payload).forEach(key => {
      if (key !== 'content') { 
        formData.append(key, payload[key]);
      }
    });
    
    formData.append('file', file);
    
    const response = await fetch(`${UPDATE_MATERIAL_IN_INSTITUTION}?${params.toString()}`, {
      method: "PUT",
      headers: {
        ...getHeadersWithoutContentType()
      },
      body: formData,
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } else {
    const response = await fetch(`${UPDATE_MATERIAL_IN_INSTITUTION}?${params.toString()}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }
};

export const deleteMaterialInstitution = async (id) => {
  if (!id) throw new Error("Material id is required for delete");
  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(
    `${DELETE_MATERIAL_IN_INSTITUTION}?${params.toString()}`,
    {
      method: "DELETE",
      headers: getHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

const getHeadersWithoutContentType = () => {
  const token = getInstitutionToken();
  if (token) {
    return { Authorization: ` ${token}` };
  }
  return {};
};